import React from "react";
import { Button } from "reactstrap";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../Tooltip";

const Index = ({ title, ...other }) => {
  const { t } = useTranslation(["configure"]);

  return (
    <CustomTooltip title={title || t("EXPORT CSV")}>
      <Button
        type="button"
        color="primary"
        style={{ minWidth: "35px", maxWidth: "36px", padding: 6 }}
        {...other}
      >
        <FontAwesomeIcon icon={faFileExcel} style={{ fontSize: "1.3rem" }} />
      </Button>
    </CustomTooltip>
  );
};

export default Index;
